import { g as gql, f as flatpickr, w as weekSelectPlugin, d as deExports, a as disableBodyScroll, e as enableBodyScroll, p as postcodeValidator, G as GraphQLClient } from "./gql.chunk.js";
import { d as deliversTypSmallVariants } from "./mappings.js";
const GRAPHQL_ENDPOINT = "https://woodox-de.myshopify.com/api/2023-10/graphql.json";
const ACCESS_TOKEN = "ac619796be6e492fcb7ffec61442c0a7";
const CONFIGURATOR_COLLECTION_HANDLE = "loseware-konfigurator";
const client = new GraphQLClient(GRAPHQL_ENDPOINT, {
  headers: {
    "Content-Type": "application/json",
    "X-Shopify-Storefront-Access-Token": ACCESS_TOKEN
  }
});
const idQuery = gql`
  query FetchCollectionProducts($collectionHandle: String!) {
    collectionByHandle(handle: $collectionHandle) {
      products(first: 100) {
        edges {
          node {
            id
            title
          }
        }
      }
    }
  }
`;
const variantQuery = gql`
    query FetchProductVariants($productId: ID!) {
        product(id: $productId) {
            variants(first: 100) {
                edges {
                    node {
                        id
                        title
                        priceV2 {
                            amount
                        }
                    }
                }
            }
        }
    }
`;
let apiMapping = void 0;
let currentVariants = [];
let currentVariant = null;
const encodeProductId = (productId) => btoa(`gid://shopify/Product/${productId}`);
const extractProductId = (globalId) => globalId.split("/").pop();
const validateStep = (input) => {
  if (input.valueAsNumber < 2e3)
    return;
  const step = 500;
  const value = input.valueAsNumber;
  if (value % step !== 0) {
    input.value = Math.round(value / step) * step + "";
  }
};
const toggleFormFields = (enable) => {
  const formFields = document.querySelectorAll(
    "#quantity, #quantity-slider,#customer_number, #power-plus,#delivery_typ, #hose-length, #delivery-type, #delivery-week, #delivery-notes, #add-to-cart-button"
  );
  formFields.forEach((field) => field.disabled = !enable);
};
const showError = (message) => {
  const errorDiv = document.getElementById("form-error");
  if (errorDiv) {
    errorDiv.textContent = message;
    errorDiv.classList.remove("hidden");
  }
};
const hideError = () => {
  const errorDiv = document.getElementById("form-error");
  if (errorDiv) {
    errorDiv.textContent = "";
    errorDiv.classList.add("hidden");
  }
};
const waitForApiMapping = () => {
  return new Promise((resolve) => {
    const interval = setInterval(() => {
      if (apiMapping) {
        clearInterval(interval);
        resolve();
      }
    }, 200);
  });
};
function showModalPower() {
  const modalBackdrop = document.getElementById("modal-backdrop");
  const modal = document.getElementById("modal-power-plus");
  const modalPanel = document.getElementById("modal-power-plus-panel");
  if (modalBackdrop && modal && modalPanel) {
    disableBodyScroll(modalPanel);
    modalBackdrop.classList.remove("tw-hidden");
    modalBackdrop.classList.add("tw-opacity-0");
    setTimeout(() => modalBackdrop.classList.replace("tw-opacity-0", "tw-opacity-100"), 10);
    modal.classList.remove("tw-hidden");
    modalPanel.classList.add("tw-opacity-0", "tw-translate-y-4", "sm:tw-translate-y-0", "sm:tw-scale-95");
    setTimeout(() => {
      modalPanel.classList.replace("tw-opacity-0", "tw-opacity-100");
      modalPanel.classList.replace("tw-translate-y-4", "tw-translate-y-0");
      modalPanel.classList.replace("sm:tw-scale-95", "sm:tw-scale-100");
    }, 10);
  }
}
function showModal(title, message, isError = false) {
  const elements = {
    backdrop: document.getElementById("modal-backdrop"),
    modal: document.getElementById("modal"),
    panel: document.getElementById("modal-panel"),
    title: document.getElementById("modal-title"),
    message: document.getElementById("modal-message"),
    confirm: document.getElementById("modal-confirm-button"),
    cancel: document.getElementById("modal-cancel-button"),
    close: document.getElementById("modal-close-button")
  };
  if (Object.values(elements).every((el) => el)) {
    disableBodyScroll(elements.panel);
    elements.title.textContent = title;
    elements.message.textContent = message;
    if (isError) {
      elements.confirm.classList.add("tw-hidden");
      elements.cancel.classList.add("tw-hidden");
      elements.close.classList.remove("tw-hidden");
    } else {
      elements.confirm.classList.remove("tw-hidden");
      elements.cancel.classList.remove("tw-hidden");
      elements.close.classList.add("tw-hidden");
    }
    elements.backdrop.classList.remove("tw-hidden");
    elements.backdrop.classList.add("tw-opacity-0");
    setTimeout(() => elements.backdrop.classList.replace("tw-opacity-0", "tw-opacity-100"), 10);
    elements.modal.classList.remove("tw-hidden");
    elements.panel.classList.add("tw-opacity-0", "tw-translate-y-4", "sm:tw-translate-y-0", "sm:tw-scale-95");
    setTimeout(() => {
      elements.panel.classList.replace("tw-opacity-0", "tw-opacity-100");
      elements.panel.classList.replace("tw-translate-y-4", "tw-translate-y-0");
      elements.panel.classList.replace("sm:tw-scale-95", "sm:tw-scale-100");
    }, 10);
  }
}
function hideModal(modalID) {
  const modalBackdrop = document.getElementById("modal-backdrop");
  const modal = document.getElementById(modalID);
  const modalPanel = document.getElementById(modalID + "-panel");
  if (modalBackdrop && modal && modalPanel) {
    enableBodyScroll(modalPanel);
    modalBackdrop.classList.replace("tw-opacity-100", "tw-opacity-0");
    setTimeout(() => modalBackdrop.classList.add("tw-hidden"), 300);
    modalPanel.classList.replace("tw-opacity-100", "tw-opacity-0");
    modalPanel.classList.replace("tw-translate-y-0", "tw-translate-y-4");
    modalPanel.classList.replace("sm:tw-scale-100", "sm:tw-scale-95");
    setTimeout(() => modal.classList.add("tw-hidden"), 300);
  }
}
function hideModalPlz() {
  hideModal("modal");
}
function activatePowerPlusAndCloseModal() {
  const powerPlusInput = document.getElementById("power-plus");
  if (powerPlusInput) {
    powerPlusInput.checked = true;
    updateVariantSelection();
    saveFormData();
  }
  hideModal("modal-power-plus");
}
function deactivatePowerPlusAndCloseModal() {
  const powerPlusInput = document.getElementById("power-plus");
  if (powerPlusInput) {
    powerPlusInput.checked = false;
    updateVariantSelection();
    saveFormData();
  }
  hideModal("modal-power-plus");
}
const fetchProductVariants = async (productId) => {
  var _a;
  try {
    const data = await client.request(variantQuery, { productId });
    if (!((_a = data == null ? void 0 : data.product) == null ? void 0 : _a.variants)) {
      console.error("Unexpected response structure:", data);
      return [];
    }
    return data.product.variants.edges.map((edge) => edge.node);
  } catch (error) {
    console.error("Error in fetchProductVariants:", error);
    return [];
  }
};
const generateMapping = (products) => {
  const plzVariantMap = {};
  products.forEach((product) => {
    const title = product.title;
    const productId = product.id;
    const numericProductId = productId.split("/").pop();
    const plzPrefixMatch = title.match(/(\d{2})/);
    if (plzPrefixMatch && numericProductId) {
      plzVariantMap[plzPrefixMatch[1]] = numericProductId;
    } else {
      console.warn(`PLZ oder ID konnte nicht aus Titel "${title}" oder ID "${productId}" extrahiert werden.`);
    }
  });
  return plzVariantMap;
};
const fetchProductsAndGenerateMapping = async () => {
  const collectionHandle = CONFIGURATOR_COLLECTION_HANDLE;
  const response = await client.request(idQuery, { collectionHandle });
  const products = response.collectionByHandle.products.edges;
  return generateMapping(products.map((edge) => edge.node));
};
const clearCart = async () => {
  try {
    const response = await fetch("/cart/clear.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      }
    });
    if (!response.ok)
      throw new Error("Fehler beim Leeren des Warenkorbs.");
  } catch (error) {
    console.error("Error clearing cart:", error);
  }
};
const addMultipleToCart = async (items) => {
  const payload = items.map((item) => ({
    id: item.id,
    quantity: item.quantity,
    properties: item.properties || void 0
  }));
  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({ items: payload })
      // Array von Artikeln senden
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.description || "Fehler beim Hinzufügen zum Warenkorb.");
    }
  } catch (error) {
    console.error(`Fehler beim Hinzufügen von Artikeln:`, error);
    showError("Fehler beim Hinzufügen von Artikeln zum Warenkorb.");
    throw error;
  }
};
const getVariantByQuantityAndPowerPlus = (quantity, powerPlus, variants) => {
  const powerPlusText = powerPlus ? "Ja" : "Nein";
  const variantTitle = `${quantity} kg / ${powerPlusText}`;
  return variants.find((v) => v.title === variantTitle) ?? null;
};
const updateCurrentVariant = () => {
  const quantityInput = document.getElementById("quantity");
  const powerPlusInput = document.getElementById("power-plus");
  if (quantityInput && powerPlusInput) {
    const quantity = parseInt(quantityInput.value, 10);
    currentVariant = getVariantByQuantityAndPowerPlus(quantity, powerPlusInput.checked, currentVariants);
  }
};
const updateVariantSelection = () => {
  updateCurrentVariant();
  checkFormValidity();
  if (currentVariant) {
    updatePrices();
  }
};
const updatePrices = () => {
  if (!currentVariant)
    return;
  const postcodeInput = document.getElementById("postcode");
  if (!(postcodeInput == null ? void 0 : postcodeInput.value.length) || postcodeInput.value.length !== 5)
    return;
  const postcodePrefix = postcodeInput.value.substring(0, 2);
  const quantityInput = document.getElementById("quantity");
  const powerPlusInput = document.getElementById("power-plus");
  const hoseLengthInput = document.getElementById("hose-length");
  const deliveryType = document.getElementById("delivery_typ");
  const variantPriceDisplay = document.getElementById("variant-price");
  const totalPriceDisplay = document.getElementById("total-price");
  if (quantityInput && powerPlusInput && hoseLengthInput && variantPriceDisplay && totalPriceDisplay) {
    const variantPrice = parseFloat(currentVariant.priceV2.amount);
    const compareAtPrice = currentVariant.compareAtPriceV2 ? parseFloat(currentVariant.compareAtPriceV2.amount) : null;
    const quantity = parseInt(quantityInput.value);
    const quantityInTons = quantity / 1e3;
    const einblaspauschale = 46.01;
    let smallDeliveryCost = 0;
    if ((deliveryType == null ? void 0 : deliveryType.value) === "small") {
      const smallVariantId = deliversTypSmallVariants[postcodePrefix];
      if (smallVariantId) {
        smallDeliveryCost = 50;
      }
    }
    let hoseLengthPrice = parseInt(hoseLengthInput.value) > 30 ? 29.43 : 0;
    const totalPrice = variantPrice + hoseLengthPrice + einblaspauschale + smallDeliveryCost;
    const displayPricePerTon = (totalPrice - einblaspauschale) / quantityInTons;
    let totalCompareAtPrice = null;
    let displayCompareAtPricePerTon = null;
    if (compareAtPrice) {
      totalCompareAtPrice = compareAtPrice + hoseLengthPrice + einblaspauschale + smallDeliveryCost;
      displayCompareAtPricePerTon = (totalCompareAtPrice - einblaspauschale) / quantityInTons;
      if (displayCompareAtPricePerTon !== displayPricePerTon) {
        variantPriceDisplay.innerHTML = `
                    <span style="text-decoration: line-through; color: rgba(230,25,56,0.76); margin-right: 5px;">
                        ${displayCompareAtPricePerTon.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €
                    </span> 
                    <span>
                        ${displayPricePerTon.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €
                    </span>`;
      } else {
        variantPriceDisplay.textContent = `${displayPricePerTon.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;
      }
    } else {
      variantPriceDisplay.textContent = `${displayPricePerTon.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;
    }
    if (totalCompareAtPrice) {
      if (totalCompareAtPrice !== totalPrice) {
        totalPriceDisplay.innerHTML = `
                    <span style="text-decoration: line-through; color: rgba(230,25,56,0.76); margin-right: 5px;">
                        ${totalCompareAtPrice.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €
                    </span> 
                    <span>
                        ${totalPrice.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €
                    </span>`;
      } else {
        totalPriceDisplay.textContent = `${totalPrice.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;
      }
    } else {
      totalPriceDisplay.textContent = `${totalPrice.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;
    }
  }
};
const checkFormValidity = () => {
  const quantityInput = document.getElementById("quantity");
  const postcodeInput = document.getElementById("postcode");
  const hoseLengthInput = document.getElementById("hose-length");
  const addToCartButton = document.getElementById("add-to-cart-button");
  if (quantityInput && postcodeInput && hoseLengthInput && addToCartButton) {
    const isQuantityValid = parseInt(quantityInput.value) >= 2e3;
    const isPostcodeValid = postcodeValidator(postcodeInput.value, "DE");
    const isHoseLengthValid = hoseLengthInput.value !== "";
    addToCartButton.disabled = !(isQuantityValid && isPostcodeValid && isHoseLengthValid);
  }
};
const saveFormData = () => {
  const quantityInput = document.getElementById("quantity");
  const customerNumberInput = document.getElementById("customer_number");
  const postcodeInput = document.getElementById("postcode");
  const powerPlusInput = document.getElementById("power-plus");
  const hoseLengthInput = document.getElementById("hose-length");
  const deliveryType = document.getElementById("delivery_typ");
  const deliveryWeekInput = document.getElementById("delivery-week");
  const deliveryNotesInput = document.getElementById("delivery-notes");
  if (currentVariant !== void 0) {
    const formData = {
      postcode: postcodeInput == null ? void 0 : postcodeInput.value,
      customer_number: customerNumberInput == null ? void 0 : customerNumberInput.value,
      quantity: quantityInput == null ? void 0 : quantityInput.value,
      powerPlus: powerPlusInput == null ? void 0 : powerPlusInput.checked,
      hoseLength: hoseLengthInput == null ? void 0 : hoseLengthInput.value,
      deliveryType: deliveryType == null ? void 0 : deliveryType.value,
      deliveryWeek: deliveryWeekInput == null ? void 0 : deliveryWeekInput.value,
      deliveryNotes: deliveryNotesInput == null ? void 0 : deliveryNotesInput.value
    };
    sessionStorage.setItem("productLoseFormData", JSON.stringify(formData));
  }
};
const loadFormData = () => {
  const savedData = sessionStorage.getItem("productLoseFormData");
  if (savedData) {
    const formData = JSON.parse(savedData);
    const elements = {
      postcode: document.getElementById("postcode"),
      customer_number: document.getElementById("customer_number"),
      quantity: document.getElementById("quantity"),
      quantitySlider: document.getElementById("quantity-slider"),
      powerPlus: document.getElementById("power-plus"),
      hoseLength: document.getElementById("hose-length"),
      deliveryType: document.getElementById("delivery_typ"),
      deliveryWeek: document.getElementById("delivery-week"),
      deliveryNotes: document.getElementById("delivery-notes")
    };
    if (elements.postcode)
      elements.postcode.value = formData.postcode || "";
    if (elements.customer_number)
      elements.customer_number.value = formData.customer_number || "";
    if (elements.quantity)
      elements.quantity.value = formData.quantity || "";
    if (elements.quantitySlider)
      elements.quantitySlider.value = formData.quantity || "";
    if (elements.powerPlus)
      elements.powerPlus.checked = formData.powerPlus || false;
    if (elements.hoseLength)
      elements.hoseLength.value = formData.hoseLength || "normal";
    if (elements.deliveryType)
      elements.deliveryType.value = formData.deliveryType || "";
    if (elements.deliveryWeek)
      elements.deliveryWeek.value = formData.deliveryWeek || "";
    if (elements.deliveryNotes)
      elements.deliveryNotes.value = formData.deliveryNotes || "";
  }
};
document.addEventListener("DOMContentLoaded", async () => {
  const postcodeInput = document.getElementById("postcode");
  const customerNumberInput = document.getElementById("customer_number");
  const quantityInput = document.getElementById("quantity");
  const quantitySlider = document.getElementById("quantity-slider");
  const powerPlusInput = document.getElementById("power-plus");
  const hoseLengthInput = document.getElementById("hose-length");
  const deliveryType = document.getElementById("delivery_typ");
  const deliveryWeekInput = document.getElementById("delivery-week");
  const deliveryNotesInput = document.getElementById("delivery-notes");
  const productForm = document.getElementById("product-form");
  const tabs = document.querySelectorAll(".tab-button");
  const tabContents = document.querySelectorAll(".tab-content");
  const nextButton = document.getElementById("bp-form-next-button");
  const submitButton = document.getElementById("add-to-cart-button");
  let currentTabIndex = 0;
  const handlePostCodeUpdate = async () => {
    hideError();
    toggleFormFields(false);
    if (!apiMapping)
      await waitForApiMapping();
    if ((postcodeInput == null ? void 0 : postcodeInput.value.length) !== 5)
      return;
    const postcodePrefix = postcodeInput.value.substring(0, 2);
    const productId = apiMapping[postcodePrefix];
    if (!productId) {
      showModal("Keine Lieferung möglich", "Für diese Postleitzahl bieten wir leider keinen Versand an.", true);
      toggleFormFields(false);
      return;
    }
    try {
      currentVariants = await fetchProductVariants(encodeProductId(productId));
      if (currentVariants.length === 0) {
        showModal("Produkt nicht verfügbar", "Für diese Postleitzahl ist dieses Produkt aktuell nicht verfügbar.", true);
        toggleFormFields(false);
        postcodeInput.value = "";
        enableTabsAndNextButton();
        return;
      }
      toggleFormFields(true);
      updateVariantSelection();
    } catch (error) {
      console.error("Fehler beim Laden der Varianten:", error);
      showModal("Fehler", "Ein Fehler ist beim Abrufen der Produktvarianten aufgetreten. Bitte versuchen Sie es erneut.", true);
    }
  };
  fetchProductsAndGenerateMapping().then((mapping) => {
    apiMapping = mapping;
  }).catch((error) => {
    console.error("Error fetching products:", error);
  });
  loadFormData();
  await handlePostCodeUpdate();
  updateVariantSelection();
  const validatePostcode = () => {
    return postcodeInput == null ? void 0 : postcodeInput.value.trim().match(/^\d{5}$/);
  };
  const enableTabsAndNextButton = () => {
    tabs.forEach((tab, index) => {
      const shouldEnable = index === 0 || validatePostcode();
      tab.disabled = !shouldEnable;
      tab.classList.toggle("tw-opacity-50", !shouldEnable);
    });
    if (nextButton) {
      nextButton.disabled = !validatePostcode();
      nextButton.classList.toggle("tw-opacity-50", !validatePostcode());
      nextButton.classList.toggle("tw-pointer-events-none", !validatePostcode());
    }
  };
  const showTab = (index) => {
    tabs.forEach((btn, i) => {
      var _a;
      btn.classList.toggle("bp-active-tab", i === index);
      (_a = tabContents[i]) == null ? void 0 : _a.classList.toggle("hidden", i !== index);
    });
    if (nextButton && submitButton) {
      nextButton.classList.toggle("hidden", index === tabs.length - 1);
      submitButton.classList.toggle("hidden", index !== tabs.length - 1);
    }
  };
  async function getMetafieldMinDate() {
    try {
      const productResponse = await fetch(`${window.Shopify.routes.root}products/holzpellets-lose-ware.js`);
      if (!productResponse.ok) {
        throw new Error(`HTTP error! status: ${productResponse.status}`);
      }
      const product = await productResponse.json();
      const metafieldResponse = await fetch(`/products/${product.handle}?view=metafields`);
      if (!metafieldResponse.ok) {
        throw new Error(`HTTP error! status: ${metafieldResponse.status}`);
      }
      const data = await metafieldResponse.json();
      if (data.metafields && data.metafields["custom.minimum_lieferdatum"]) {
        const minDateValue = data.metafields["custom.minimum_lieferdatum"];
        const minDate = new Date(minDateValue);
        if (!isNaN(minDate.getTime())) {
          return minDate;
        }
      } else {
        console.error("Metafeld 'custom.minimum_lieferdatum' nicht gefunden.");
      }
    } catch (error) {
      console.error("Fehler beim Laden des Metafelds:", error);
    }
    return null;
  }
  if (deliveryWeekInput) {
    getMetafieldMinDate().then((metafieldMinDate) => {
      const defaultMinDate = new Date(Date.now() + 14 * 24 * 60 * 60 * 1e3);
      const minDate = metafieldMinDate || defaultMinDate;
      const maxDate = new Date(minDate.getTime() + 28 * 24 * 60 * 60 * 1e3);
      flatpickr(deliveryWeekInput, {
        // @ts-ignore
        plugins: [new weekSelectPlugin({})],
        weekNumbers: true,
        locale: deExports.German,
        dateFormat: "W",
        minDate,
        maxDate,
        onChange: function() {
          this.selectedDates[0] ? this.config.getWeek(this.selectedDates[0]) : null;
        }
      });
    });
  }
  const saveAndUpdate = () => {
    saveFormData();
    updateVariantSelection();
  };
  window.addEventListener("load", enableTabsAndNextButton);
  postcodeInput == null ? void 0 : postcodeInput.addEventListener("input", enableTabsAndNextButton);
  tabs.forEach((tab, index) => {
    tab.addEventListener("click", () => {
      if (!tab.disabled) {
        currentTabIndex = index;
        showTab(currentTabIndex);
      }
    });
  });
  nextButton == null ? void 0 : nextButton.addEventListener("click", (event) => {
    event.preventDefault();
    if (currentTabIndex < tabs.length - 1) {
      currentTabIndex++;
      showTab(currentTabIndex);
    }
  });
  const moreInfoButton = document.getElementById("power-plus-more-button");
  const closeModalButton = document.getElementById("close-modal-button");
  const withPowerPlusButton = document.getElementById("close-modal-button");
  const withoutPowerPlusButton = document.getElementById("close-modal-button2");
  const closeButton = document.getElementById("modal-close-button");
  moreInfoButton == null ? void 0 : moreInfoButton.addEventListener("click", (event) => {
    event.preventDefault();
    showModalPower();
  });
  closeModalButton == null ? void 0 : closeModalButton.addEventListener("click", () => hideModal("modal"));
  withPowerPlusButton == null ? void 0 : withPowerPlusButton.addEventListener("click", activatePowerPlusAndCloseModal);
  withoutPowerPlusButton == null ? void 0 : withoutPowerPlusButton.addEventListener("click", deactivatePowerPlusAndCloseModal);
  closeButton == null ? void 0 : closeButton.addEventListener("click", hideModalPlz);
  quantityInput == null ? void 0 : quantityInput.addEventListener("input", () => {
    validateStep(quantityInput);
    if (quantitySlider)
      quantitySlider.value = quantityInput.value;
    saveAndUpdate();
  });
  quantitySlider == null ? void 0 : quantitySlider.addEventListener("input", () => {
    validateStep(quantitySlider);
    if (quantityInput)
      quantityInput.value = quantitySlider.value;
    saveAndUpdate();
  });
  postcodeInput == null ? void 0 : postcodeInput.addEventListener("input", async () => {
    saveFormData();
    await handlePostCodeUpdate();
  });
  [
    { element: customerNumberInput, event: "input" },
    { element: customerNumberInput, event: "change" },
    { element: deliveryType, event: "input" },
    { element: hoseLengthInput, event: "change" },
    { element: powerPlusInput, event: "change" },
    { element: deliveryWeekInput, event: "input" },
    { element: deliveryNotesInput, event: "input" }
  ].forEach(({ element, event }) => {
    element == null ? void 0 : element.addEventListener(event, saveAndUpdate);
  });
  productForm == null ? void 0 : productForm.addEventListener("submit", async (e) => {
    e.preventDefault();
    try {
      await clearCart();
      const formData = new FormData(e.target);
      const cartItems = [];
      const postcodePrefix = postcodeInput.value.substring(0, 2);
      if (currentVariant) {
        cartItems.push({
          id: extractProductId(currentVariant.id),
          quantity: 1,
          properties: {
            "Postleitzahl": formData.get("properties[Postleitzahl]"),
            "Kundennummer": formData.get("properties[customer_number]"),
            "Power Plus Upgrade": formData.get("properties[Power Plus Upgrade]") ? "Ja" : "Nein",
            "Schlauchlänge": formData.get("properties[Schlauchlänge]"),
            "Tankwagen": formData.get("properties[Tankwagen]"),
            "Lieferwoche": formData.get("properties[Lieferwoche]"),
            "Lieferhinweise": formData.get("properties[Lieferhinweise]")
          }
        });
      }
      cartItems.push({
        id: "44580851450014",
        quantity: 1
      });
      if (parseInt(formData.get("properties[Schlauchlänge]"), 10) > 30) {
        cartItems.push({
          id: "44576236994718",
          quantity: 1
        });
      }
      if (formData.get("properties[Tankwagen]") === "small") {
        const smallTranspoterVariants = await fetchProductVariants(encodeProductId("8148877344926"));
        const deliversTypSmallVariantss = generateMapping(smallTranspoterVariants);
        const smallVariantId = deliversTypSmallVariantss[postcodePrefix];
        if (smallVariantId) {
          cartItems.push({
            id: smallVariantId,
            quantity: 1
          });
        }
      }
      cartItems.reverse();
      await addMultipleToCart(cartItems);
      window.location.href = "/checkout";
    } catch (error) {
      console.error("Error adding items to cart:", error);
      showError("Ein Fehler ist beim Hinzufügen der Artikel zum Warenkorb aufgetreten. Bitte versuchen Sie es erneut.");
    }
  });
});
